import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useLanguage } from '../context/LanguageContext';
import api from '../lib/api';

const orangeIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

const DR_CENTER = [18.7357, -70.1627];
const DR_ZOOM = 8;

const MapSection = () => {
  const { t } = useLanguage();
  const [airports, setAirports] = useState([]);
  const [filter, setFilter] = useState('airport');

  useEffect(() => {
    api.get('/airports').then(r => setAirports(r.data)).catch(() => {});
  }, []);

  const filtered = airports.filter(a => filter === 'all' ? true : a.type === filter);

  return (
    <section className="py-24 bg-gradient-to-b from-[#0f0f0f] to-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[#ff6b1a] text-sm font-bold tracking-[0.2em] uppercase">{t.map.tag}</span>
          <h2 className="text-4xl md:text-5xl font-black text-white mt-3 mb-4">{t.map.title}</h2>
          <p className="text-white/60 max-w-3xl mx-auto text-lg">{t.map.subtitle}</p>
        </div>

        <div className="flex justify-center gap-2 mb-6">
          <button onClick={() => setFilter('airport')} className={`px-5 py-2 rounded-md text-sm font-semibold transition-colors ${filter === 'airport' ? 'bg-[#ff6b1a] text-white' : 'bg-white/5 text-white/70 hover:bg-white/10'}`}>{t.map.airports}</button>
          <button onClick={() => setFilter('port')} className={`px-5 py-2 rounded-md text-sm font-semibold transition-colors ${filter === 'port' ? 'bg-[#ff6b1a] text-white' : 'bg-white/5 text-white/70 hover:bg-white/10'}`}>{t.map.destinations}</button>
        </div>

        <div className="glass-card rounded-2xl overflow-hidden border border-white/10" style={{ height: 480 }}>
          <MapContainer center={DR_CENTER} zoom={DR_ZOOM} style={{ height: '100%', width: '100%' }} scrollWheelZoom={false}>
            <TileLayer url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png" attribution='&copy; <a href="https://carto.com/">CARTO</a>' />
            {filtered.map(a => (
              <Marker key={a.id} position={[a.lat, a.lng]} icon={orangeIcon}>
                <Popup>
                  <div className="text-white">
                    <strong>{a.name}</strong><br />
                    <span className="text-xs opacity-70">{a.code} • {a.city}</span>
                  </div>
                </Popup>
              </Marker>
            ))}
          </MapContainer>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
